import vueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import { componentsMixins } from "core/materialLoader"
export default {
  components: {
    vueDragResizable,
    ...componentsMixins
  }
}
